var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F8CA18",
  fillRule: "evenodd",
  d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 0v4a2 2 0 0 0 2 2h4z",
  opacity: 0.6
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 8,
  x: 2,
  y: 13,
  fill: "#F7F8FA",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F8CA18",
  d: "M4 19v-4h1.536q.419 0 .722.162.305.16.47.461.165.3.165.709 0 .416-.169.707-.168.29-.48.441-.309.15-.735.15h-.971v-.76h.804a.9.9 0 0 0 .34-.058.43.43 0 0 0 .209-.175.6.6 0 0 0 .07-.305.6.6 0 0 0-.07-.307.44.44 0 0 0-.21-.183.8.8 0 0 0-.339-.063H4.9V19zm2.094-1.828L7.02 19h-.98l-.909-1.828zM8.19 19h-.965l1.255-4h1.196l1.255 4h-.966l-.873-2.992h-.03zm-.128-1.574h2.02v.734h-2.02zM11.82 19l-1.083-4h.993l.561 2.621h.031L12.963 15h.81l.642 2.627h.03L15.008 15H16l-1.08 4h-.867l-.67-2.426h-.03L12.684 19z"
})));
export default SvgRow;